import { Skeleton } from "@/components/ui";

/** Matches the card's resting state: tags are hidden until hover, so the detail rows sit on the bottom inset. */
export function ProductCardSkeleton() {
  return (
    <div className="relative aspect-3/2 w-full" aria-hidden="true">
      <Skeleton className="absolute inset-0 !rounded-md" />
      <div className="absolute inset-x-3 bottom-3 flex flex-col gap-1">
        <div className="flex h-5 items-center justify-between gap-3">
          <Skeleton className="h-4 w-3/5" />
          <Skeleton className="h-4 w-10" />
        </div>
        <div className="flex h-5 items-center gap-1.5">
          <Skeleton className="size-5 !rounded-full" />
          <Skeleton className="h-3 w-1/3" />
          <Skeleton className="ml-auto h-3 w-14" />
        </div>
      </div>
    </div>
  );
}
